/** Display labels for the Governed Agent Unit billing unit (short form). */
export const GAU_SINGULAR = "GAU";
export const GAU_PLURAL = "GAUs";

/** Docs page explaining the self-serve plan and its GAU-based pricing. */
export const SELF_SERVE_PLAN_DOCS_URL =
  "https://docs.superblocks.com/admin/self-serve-plan";

/** Hover tooltip copy for GauTerm. */
export const GAU_TOOLTIP_SINGULAR = "Governed Agent Unit";
export const GAU_TOOLTIP_PLURAL = "Governed Agent Units";

export function gauLabel(plural = false): string {
  return plural ? GAU_PLURAL : GAU_SINGULAR;
}

export function gauTooltip(plural = false): string {
  return plural ? GAU_TOOLTIP_PLURAL : GAU_TOOLTIP_SINGULAR;
}
